import SidePanelHeader from "../components/SidePanelHeader"
import { useNavigate } from "react-router"
import * as Navigation from "../../../../../modules/Navigation";
import SidePanelInfo from "../components/SidePanelInfo"
import { Intent } from "../../../recallWizard/recallData";
import { usePermissions } from "../../../../../modules/auth/Permissions/PermissionContext";
import { hasPermission } from "../../../../../modules/auth/Permissions/PermissionModule";
import { PermissionTypes, PermissionConcerns } from "../../../../../modules/auth/Permissions/PermissionStrings";

export default function SidePanelRecallLineItem({ data, onViewPage }: any) {
    const navigate = useNavigate();
    const { permissions } = usePermissions();

    const navigationRouteMap = {
        [Intent.PartCase]: "specimens",
        [Intent.WholeCase]: "cases",
        [Intent.WholeBox]: "packingBoxes",
    }

    function viewLineItemEntity() {
        Navigation.view.navigate(navigate, navigationRouteMap[data.intentKey as Intent], data.entityId)
    }

    const isWholeBox = data.intentKey === Intent.WholeBox;
    const canNavigate = isWholeBox 
        ? hasPermission(permissions, PermissionTypes.read, PermissionConcerns.Inventory_Containers)
        : true;
    const cantNavigate = isWholeBox ? !canNavigate : false;

    return (<>
        {data &&
            <>
                {!onViewPage && <SidePanelHeader descriptor={data.intent} value={data.reference} statuses={data.status} onClick={data.entityId && canNavigate ? viewLineItemEntity : undefined} cantNavigate={cantNavigate} />}
                <SidePanelInfo
                    values={[
                        { label: "CellNass Notes", value: data.notes },
                        ...(data.requestorComments ? [{ label: "Customer Comments", value: data.requestorComments }] : []),
                        ...(data.quantity != null ? [{ label: "Quantity", value: `X ${data.quantity}` }] : []),
                    ]}
                />
            </>
        }
    </>)
}